/* eslint-disable max-lines-per-function */
import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { devtools } from 'zustand/middleware';
import { AnalogueModelDetail } from '../api/generated';
import { analogueModelDefault } from '../constants/analogueModelDefault';

type ModelFormState = {
  analogueModel: AnalogueModelDetail;
  analogueModelImageURL: string;
};

type ModelFormActions = {
  setAnalogueModel: (analogueModel: AnalogueModelDetail) => void;
  setAnalogueModelDefault: () => void;
  setAnalogueModelImage: (image: string) => void;
};

export const useModelFormStore = create<ModelFormState & ModelFormActions>()(
  devtools(
    immer((set) => ({
      analogueModel: analogueModelDefault,
      analogueModelImageURL: '',
      setAnalogueModel: (analogueModel: AnalogueModelDetail) =>
        set(
          (state) => {
            state.analogueModel = analogueModel;
          },
          undefined,
          'analogueModel/setAnalogueModel',
        ),
      setAnalogueModelDefault: () =>
        set((state) => {
          state.analogueModel = analogueModelDefault;
          state.analogueModelImageURL = '';
        }),
      setAnalogueModelImage: (image: string) =>
        set((state) => {
          state.analogueModelImageURL = image;
        }),
    })),
  ),
);
